import { render, staticRenderFns } from "./TabInformation.vue?vue&type=template&id=ea8e35aa&"
import script from "./TabInformation.vue?vue&type=script&lang=js&"
export * from "./TabInformation.vue?vue&type=script&lang=js&"
import style0 from "./TabInformation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea8e35aa')) {
      api.createRecord('ea8e35aa', component.options)
    } else {
      api.reload('ea8e35aa', component.options)
    }
    module.hot.accept("./TabInformation.vue?vue&type=template&id=ea8e35aa&", function () {
      api.rerender('ea8e35aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabInformation.vue"
export default component.exports